module.exports = __webpack_public_path__ + "img/upload-image-iconic.f05ec946.png";